// extracted by mini-css-extract-plugin
export default {"page":"FW-z","cartModal":"GW-z","checkout":"HW-z","placeholder":"IW-z","account":"JW-z"};